module.exports = __webpack_public_path__ + "img/caseset.008cf052.png";